var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_94905",
    "data-name": "Group 94905",
    transform: "translate(-1977.811 16211.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6956",
    "data-name": "Path 6956",
    d: "M24,0A24,24,0,1,1,0,24,24,24,0,0,1,24,0Z",
    transform: "translate(1977.811 -16211.189)",
    fill: "#ffe6de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-ringing-phone_1_",
    "data-name": "icons8-ringing-phone (1)",
    d: "M13.926,3.183a.464.464,0,0,0-.184.893,5.537,5.537,0,0,1,.956.515.464.464,0,1,0,.524-.766,6.447,6.447,0,0,0-1.116-.6.464.464,0,0,0-.18-.04Zm-4.794.869c-2.44,0-4.5.526-5.507,1.406a1.91,1.91,0,0,0-.647,1.784l.1.353a1.48,1.48,0,0,0,1.6,1.087l.785-.1A1.446,1.446,0,0,0,6.745,7.521l.216-.959A.257.257,0,0,1,7.08,6.4a8.5,8.5,0,0,1,2.052-.184,8.495,8.495,0,0,1,2.052.184.282.282,0,0,1,.127.185l.2.909a1.453,1.453,0,0,0,1.282,1.088l.8.1c.05,0,.1.007.15.007a1.467,1.467,0,0,0,1.436-1.083l.1-.334.007-.03a1.911,1.911,0,0,0-.647-1.785C13.631,4.579,11.573,4.053,9.133,4.053Zm-1.089,3.4a.464.464,0,0,0-.456.47v.8l-1.1.551a4.69,4.69,0,0,0-2.607,4.218,1.7,1.7,0,0,0,1.7,1.7h7.11a1.7,1.7,0,0,0,1.7-1.7,4.69,4.69,0,0,0-2.607-4.218l-1.1-.551v-.8a.464.464,0,1,0-.927,0v.464H8.514V7.918a.464.464,0,0,0-.471-.47ZM2.92,9.217a.464.464,0,0,0-.244.842,3.327,3.327,0,0,0,1.258.566.464.464,0,1,0,.2-.906,2.4,2.4,0,0,1-.906-.409.464.464,0,0,0-.258-.093H2.92Zm4.513,1.638a.464.464,0,1,1-.464.464A.464.464,0,0,1,7.432,10.855Zm1.7,0a.464.464,0,1,1-.464.464A.464.464,0,0,1,9.133,10.855Zm1.7,0a.464.464,0,1,1-.464.464A.464.464,0,0,1,10.833,10.855ZM7.432,12.4a.464.464,0,1,1-.464.464A.464.464,0,0,1,7.432,12.4Zm1.7,0a.464.464,0,1,1-.464.464A.464.464,0,0,1,9.133,12.4Zm1.7,0a.464.464,0,1,1-.464.464A.464.464,0,0,1,10.833,12.4Z",
    transform: "translate(1992.859 -16196.373)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_112053",
    "data-name": "Group 112053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_55784",
    "data-name": "Rectangle 55784",
    transform: "translate(1989.811 -16199.189)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-satisfaction",
    d: "M5.042,6a5.042,5.042,0,1,0,5.042,5.042A5.048,5.048,0,0,0,5.042,6ZM16.958,6A5.042,5.042,0,1,0,22,11.042,5.048,5.048,0,0,0,16.958,6ZM6.646,9.208a.688.688,0,1,1-.687.688A.687.687,0,0,1,6.646,9.208Zm11.917,0a.688.688,0,1,1-.687.688A.687.687,0,0,1,18.563,9.208Zm-15.125,0a.687.687,0,1,1-.687.688A.687.687,0,0,1,3.438,9.209Zm11.917,0a.687.687,0,1,1-.687.688A.687.687,0,0,1,15.354,9.209ZM5.042,11.5a1.793,1.793,0,0,1,1.823,1.278.459.459,0,0,1-.448.555H3.667a.459.459,0,0,1-.448-.555A1.793,1.793,0,0,1,5.042,11.5Zm10.542,0h2.75a.459.459,0,0,1,.448.555,1.793,1.793,0,0,1-1.823,1.278,1.793,1.793,0,0,1-1.823-1.278.459.459,0,0,1,.448-.555ZM11,16.083a.685.685,0,0,0-.429.15,5.089,5.089,0,0,0-1.846,2.6H2.063a.688.688,0,1,0,0,1.375H8.708v1.6A.687.687,0,0,0,9.4,22.5H12.6a.687.687,0,0,0,.688-.687v-1.6h6.646a.688.688,0,1,0,0-1.375H13.275a5.089,5.089,0,0,0-1.846-2.6A.685.685,0,0,0,11,16.083Z",
    transform: "translate(1990.811 -16201.189)",
    fill: "#F15A29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyIcon);
export default __webpack_public_path__ + "static/media/surveyIcon.d5a495aeb7c73e26494354c4c8f7dac7.svg";
export { ForwardRef as ReactComponent };